import { PricelistListDTO } from '../pricelist/pricelist-list.dto';
import { ContactListDTO } from '../contact/contact-list.dto';
import { AddressListDTO } from '../address/address-list.dto';
import { TeamAccessDTO } from '../team/team-access.dto';
import { ProductListDTO } from '../product/product-list.dto';

export class AccountDTO extends TeamAccessDTO {

    name: string;

    friendlyName: string;

    description: string;

    website: string;

    email: string;

    phone: string;

    vatNo: string;

    industry: number;

    invoiceBy: number;

    contacts: Array<ContactListDTO>;

    addresses: Array<AddressListDTO>;

    pricelists: Array<PricelistListDTO>;

    products: Array<ProductListDTO>;

}
